import { FETCH_BANKS, LOAD_BANK_LIST, SET_ZWALLET_TRANSFER, SET_REDIRECT } from './types';

export function fetchBanks(data) {
  return {
    type: FETCH_BANKS,
    payload: data
  }
}

export function setRedirect(data) {
  return {
    type: SET_REDIRECT,
    payload: data
  }
}

export function loadBanks() {
  return { type: LOAD_BANK_LIST };
}

export function setZwalletTransfer(data) {
  return {
    type: SET_ZWALLET_TRANSFER,
    payload: data
  }
} 


// WEBPACK FOOTER //
// ./src/ZWallet/Transfer/actions.js